import React, { useCallback, useEffect, useState } from "react";
import {
  Box,
  TextField,
  Button,
  Grid,
  Typography,
  Modal,
  useMediaQuery,
} from "@mui/material";
import GCTitleSticky from "../../../Component/Common/ReuseableComponent/GCTitleSticky";
import { CmpButton } from "../../../Component/Common/ToolBox/ToolBox";
import { DataGrid } from "@mui/x-data-grid";
import { Get_PutAway_DOCUMENTNO_GETROW } from "../PutAwayGenerationAction";
import { DataGridPro } from "@mui/x-data-grid-pro";

const VoucherModal = ({
  open = false,
  fCloseSearchModal = () => {},
  xOnRowClickSearch = () => {},
  xTitle = "",
  anydata = "",
  vocType = "",
}) => {
  const vMediaQuery = useMediaQuery("(max-width:850px)");
  const [row, setRow] = useState([]);
  const [column, setcolumn] = useState([
    {
      field: "AcCd",
      headerName: "AcCd",
      width: 100,
      hide: false,
    },
    {
      field: "Name1",
      headerName: "Name1",
      flex: 1,
      hide: false,
    },
  ]);
  const [sModalObj, setModalObj] = useState({
    anyData: anydata,
    name: "",
    code: "",
  });
  const fCheckKey = (event) => {
    if (event.keyCode === 40) {
      var selectedLength =
        document.getElementsByClassName("Mui-selected").length;
      if (selectedLength === 0) {
        let tabel = document.getElementById("table-main-grid-4");
        // tabel?.getElementsByClassName("MuiDataGrid-row")[0].firstChild?.click();
        tabel?.getElementsByClassName("MuiDataGrid-row")[0].firstChild?.focus();
      }
    }
  };

  const onChange = (e) => {
    setModalObj((pre) => ({ ...pre, [e.target.name]: e.target.value }));
  };
  useEffect(() => {
    setTimeout(() => {
      document.onkeydown = fCheckKey;
    }, 1000);
  }, []);

  const getSearch = async (
    xanydata = sModalObj.anyData,
    xcode = sModalObj.code,
    xName = sModalObj.name
  ) => {
    let resp = await Get_PutAway_DOCUMENTNO_GETROW(
      vocType,
      xanydata,
      "N",
      xanydata,
      xcode,
      xName
    );
    setModalObj((pre) => ({ ...pre, anyData: xanydata }));
    setRow(resp);
  };

  useEffect(() => {
    if (open) {
      getSearch(anydata);
      setTimeout(() => {
        document.getElementsByName("anyData")[0]?.focus();
      }, 100);
    } else {
      setRow([]);
      setModalObj({ anyData: "", name: "", code: "" });
    }
  }, [open]);

  return (
    <Modal
      open={open}
      onClose={fCloseSearchModal}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <div className="container-fluid">
        <Box sx={{ overflow: "auto" }} className="model-GCStockTransfer">
          <GCTitleSticky title={xTitle} onClose={fCloseSearchModal} />

          <div className="p-2">
            <Grid container spacing={1} columns={{ xs: 12, sm: 8, md: 12 }}>
              <Grid
                item
                xs={12}
                sm={12}
                md={4}
                className="gnr-item-search-label"
              >
                <Grid
                  container
                  spacing={1}
                  columns={{ xs: 12, sm: 12, md: 12 }}
                >
                  <Grid
                    item
                    xs={3}
                    sm={3}
                    md={3}
                    className="gnr-item-search-label"
                  >
                    Any Data
                  </Grid>
                  <Grid
                    item
                    xs={9}
                    sm={9}
                    md={9}
                    className="gnr-item-search-label"
                  >
                    <input
                      autoComplete="off"
                      className="form-control form-control-sm"
                      type="text"
                      name="anyData"
                      value={sModalObj.anyData}
                      onKeyUp={(e) => {
                        if (e.key === "Enter" || e._reactName === "onClick") {
                          getSearch();
                        }
                      }}
                      onChange={(e) => {
                        onChange(e);
                      }}
                    />
                  </Grid>
                </Grid>
              </Grid>

              <Grid
                item
                xs={12}
                sm={12}
                md={4}
                className="gnr-item-search-label"
              >
                <Grid
                  container
                  spacing={1}
                  columns={{ xs: 12, sm: 12, md: 12 }}
                >
                  <Grid item xs={3} className="gnr-item-search-label">
                    Name
                  </Grid>
                  <Grid item xs={9} className="gnr-item-search-label">
                    <input
                      autoComplete="off"
                      className="form-control form-control-sm"
                      type="text"
                      name="name"
                      value={sModalObj.name}
                      onKeyUp={(e) => {
                        if (e.key === "Enter" || e._reactName === "onClick") {
                          getSearch();
                        }
                      }}
                      onChange={(e) => {
                        onChange(e);
                      }}
                    />
                  </Grid>
                </Grid>
              </Grid>
              <Grid
                item
                xs={12}
                sm={12}
                md={4}
                className="gnr-item-search-label"
              >
                <Grid
                  container
                  spacing={1}
                  columns={{ xs: 12, sm: 12, md: 12 }}
                >
                  <Grid item xs={3} className="gnr-item-search-label">
                    Code
                  </Grid>
                  <Grid item xs={9} className="gnr-item-search-label">
                    <input
                      autoComplete="off"
                      className="form-control form-control-sm"
                      type="text"
                      name="code"
                      value={sModalObj.code}
                      onKeyUp={(e) => {
                        if (e.key === "Enter" || e._reactName === "onClick") {
                          getSearch();
                        }
                      }}
                      onChange={(e) => {
                        onChange(e);
                      }}
                    />
                  </Grid>
                </Grid>
              </Grid>
              <Grid
                item
                xs={12}
                sm={12}
                md={12}
                className="gnr-item-search-label align-self-center  "
              >
                <Grid
                  container
                  spacing={0}
                  columns={{ xs: 12, sm: 12, md: 12 }}
                  className={"justify-content-end"}
                >
                  <Grid
                    item
                    xs={4}
                    sm={4}
                    md={2}
                    className="gnr-item-search-label mt-2"
                  >
                    <CmpButton
                      xbtnName="Load"
                      xOnClick={(e) => {
                        if (e.key === "Enter" || e._reactName === "onClick") {
                          getSearch();
                        }
                      }}
                      xVariant="contained"
                      xDisabled={false}
                      xSize="small"
                      // xSendIcon={<RemoveRedEyeIcon />}
                    />
                  </Grid>
                  <Grid
                    item
                    xs={4}
                    sm={4}
                    md={2}
                    className="gnr-item-search-label mt-2"
                  >
                    <CmpButton
                      xbtnName="Clear"
                      xOnClick={(e) => {
                        setRow([]);
                        setModalObj({ anyData: "", name: "", code: "" });
                      }}
                      xVariant="contained"
                      xDisabled={false}
                      xSize="small"
                      // xSendIcon={<RemoveRedEyeIcon />}
                    />
                  </Grid>
                  <Grid
                    item
                    xs={4}
                    sm={4}
                    md={2}
                    className="gnr-item-search-label mt-2"
                  >
                    <CmpButton
                      xbtnName="Cancel"
                      xOnClick={(e) => {
                        fCloseSearchModal(e);
                        setRow([]);
                        setModalObj({ anyData: "", name: "", code: "" });
                      }}
                      xVariant="contained"
                      xDisabled={false}
                      xSize="small"
                      // xSendIcon={<RemoveRedEyeIcon />}
                    />
                  </Grid>
                </Grid>
              </Grid>
            </Grid>

            <Grid container spacing={1} columns={{ xs: 4, sm: 4, md: 12 }}>
              <Grid item xs={12} className="gnr-item-search-label mt-2">
                <div
                  style={{
                    height: vMediaQuery ? "43vh" : "58vh",
                    width: "100%",
                  }}
                  id="table-main-grid-4"
                >
                  <DataGridPro
                    rowHeight={30}
                    headerHeight={40}
                    getRowClassName={(params) =>
                      params.indexRelativeToCurrentPage % 2 === 0
                        ? "mui-even-row"
                        : "mui-odd-row"
                    }
                    sx={{
                      border: 1,
                      borderColor: "primary.light",
                    }}
                    getRowId={(row) => row.AcCd}
                    rows={row}
                    columns={column}
                    onCellKeyDown={(newSelectionModel, e) => {
                      if (e.key === "Enter") {
                        xOnRowClickSearch(newSelectionModel);
                      }
                    }}
                    onRowClick={xOnRowClickSearch}
                    hideFooter={row.length < 100}
                    // components={{
                    //   Toolbar: GridToolbar,
                    // }}
                  />
                </div>
              </Grid>
            </Grid>
          </div>
        </Box>
      </div>
    </Modal>
  );
};

export default VoucherModal;
